<template>
    <div>
        <login-form></login-form>
    </div>
</template>

<script>
    import LoginFormVue from '../custom-components/LoginForm.vue'
    
    export default {
        components: {
            'login-form': LoginFormVue
        },
    }
</script>
